import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PdfViewerComponent } from "../modules/protocols/viewer/pdf-viewer/pdf-viewer.component";

@Injectable({
	providedIn: "root",
})
export class DocumentViewerService {
	private dialog = inject(MatDialog);

	viewDocument(content: Uint8Array) {
		const dialogRef = this.dialog.openDialogs.find(
			(dialog) => dialog.componentInstance instanceof PdfViewerComponent
		);
		if (dialogRef) {
			dialogRef.close();
		}

		this.dialog.open(PdfViewerComponent, {
			data: content,
			width: "60%",
			height: "70%",
			disableClose: true,
			autoFocus: false,
		});
	}
}
